import { RightOutlined } from "@ant-design/icons";
import React from "react";
import InView from "react-intersection-observer";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import {
  getImageOrVideoPath,
  handleChangeIntersection,
} from "../../shared/helpers";
import "./style.scss";

const SectionCategoryInformationV2 = (props: any) => {
  const { sectionItem, history } = props;

  const colors: ISectionCSS = {
    "--color": sectionItem.color || "#000",
    "--colorTitle": sectionItem.color_title || "#000",
    "--colorContent": sectionItem.color_content || "#000",
  };

  const handleClick = (e: any, url: string = "/") => {
    e.preventDefault();
    history.push(url);
  };

  return sectionItem ? (
    <div style={colors} className="kd-section-category-information-v2">
      <div className="kd-section-category-information-v2-img">
        <img src={getImageOrVideoPath(sectionItem.images)} alt="" />
      </div>
      <div className="kd-section-category-information-v2-body">
        <InView
          triggerOnce
          onChange={(inView, entry) =>
            handleChangeIntersection(
              inView,
              entry,
              "background-color-to-bottom-animation"
            )
          }>
          <div className="kd-section-category-information-v2-body-content">
            <div className="kd-section-category-information-v2-body-content-title main-title">
              {sectionItem.title}
            </div>
            <div className="kd-section-category-information-v2-body-content-description main-content">
              {sectionItem.content}
            </div>
            <div className="kd-section-actions kd-section-category-information-v2-body-content-actions main-content">
              <a onClick={(e: any) => handleClick(e, sectionItem.url)}>
                Chi tiết <RightOutlined style={{ fontSize: 10 }} />
              </a>
              <a onClick={(e: any) => handleClick(e, sectionItem.url_products)}>
                Mua ngay <RightOutlined style={{ fontSize: 10 }} />
              </a>
            </div>
          </div>
        </InView>
      </div>
    </div>
  ) : null;
};

export default SectionCategoryInformationV2;
